import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

interface GxPrimarySmallButtonProps {
  handleSubmit?: (e: React.FormEvent) => void;
  label?: string;
  type?: "button" | "submit";
  buttonloading?: boolean;
  submitDisabled?: boolean;
  disabled?: boolean;
}
const GxPrimarySmallButton: React.FC<GxPrimarySmallButtonProps> = ({
  handleSubmit,
  label = "",
  type,
  submitDisabled,
}) => {
  const { t } = useTranslation();
  return (
    <Button
      type={type}
      onClick={handleSubmit}
      disabled={submitDisabled}
      className="gx-dialog-action-button-small gx-submit-for-approval-small "
    >
      <span className="gx-h4-small"> {t(label)}</span>
    </Button>
  );
};

export default GxPrimarySmallButton;
